export const JP_COUNTRY_ID = 1050
export const TW_COUNTRY_ID = 2000

export const getPrefectureCountryId = (countryCode?: string | string[]): number => {
  const normalizedCountryCode = Array.isArray(countryCode) ? countryCode[0] : countryCode

  return normalizedCountryCode?.toLowerCase() === 'twn' ? TW_COUNTRY_ID : JP_COUNTRY_ID
}
